import { initAuthInterceptor } from './auth-interceptor';
import { initErrorHandlerInterceptor } from './error-handler-interceptor';
var AjaxInterceptor = require('./../ajax-interceptor');

function initGlobalInterceptor(token) {
  hookSetRequestHeader();

  initAuthInterceptor(token);

  initErrorHandlerInterceptor();

  AjaxInterceptor.wire();
}

function hookSetRequestHeader() {
  XMLHttpRequest.prototype.wrappedSetRequestHeader = XMLHttpRequest.prototype.setRequestHeader;

  // Override the existing setRequestHeader function so that it stores the headers
  XMLHttpRequest.prototype.setRequestHeader = function(header, value) {
    // Call the wrappedSetRequestHeader function first
    // so we get exceptions if we are in an erronous state etc.
    header = header.toLocaleLowerCase();
    this.wrappedSetRequestHeader(header, value);

    // Create a headers map if it does not exist
    if (!this.requestHeaders) {
      this.requestHeaders = {};
    }

    // Create a list for the header that if it does not exist
    if (!this.requestHeaders[header]) {
      this.requestHeaders[header] = [];
    }

    // Add the value to the header
    this.requestHeaders[header].push(value);
  };
}

export { initGlobalInterceptor };
